import toast from "react-hot-toast";
 const toastOptions = {
    position: "top-center",
    // autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

const SuccessAlert = (data,) => {
  console.log('data', data);
  
      // Always show success message
      toast.success(data || "Operation completed successfully.", toastOptions);

      // if (data.data) {
      //   if (Array.isArray(data.data)) {
      //     console.log("✅ Success with array data:", data.data);
      //   } else if (typeof data.data === "object") {
      //     console.log("✅ Success with object data:", data.data);
      //   }
      // }
};

export default SuccessAlert;
